// Set the endpoint to the route set in the server
export const apiEndpoint = '/api/user/referrals'
